var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommentQuestion = function SvgCommentQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#184BFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.417 13.505a.417.417 0 0 1-.833 0m.833 0a.417.417 0 1 0-.833 0m.833 0h-.833m-1.25-4.583v-.417a1.667 1.667 0 1 1 3.333 0v.101c0 .47-.186.919-.518 1.25L10 11.006m8.334-.834A8.333 8.333 0 0 1 10 18.505c-.95 0-1.763-.135-2.52-.405-.714-.256-1.071-.384-1.208-.416-1.265-.298-1.79.57-2.88.75a.833.833 0 0 1-.968-.89c.04-.472.366-.92.497-1.374.271-.945-.097-1.66-.486-2.5a8.333 8.333 0 1 1 15.899-3.498"
  })));
};
export default SvgCommentQuestion;